module.exports = __webpack_public_path__ + "img/10982263_942710432438078_424453071622348709_n.22631ff0.jpg";